import { render, staticRenderFns } from "./MateriaPrima.vue?vue&type=template&id=03c44280"
import script from "./MateriaPrima.vue?vue&type=script&lang=js"
export * from "./MateriaPrima.vue?vue&type=script&lang=js"
import style0 from "./MateriaPrima.vue?vue&type=style&index=0&id=03c44280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports